<template>
	<div class="icp">
<!--		<img class="icp-icon" src="../../assets/image/icp_logo.png">-->
		<a target="_blank" :href="icpUrl"></a>
	</div>
</template>

<script>
export default {
	data() {
		return {
			icpUrl: process.env.VUE_APP_ICP_URL || ''
		}
	}
}
</script>

<style lang="scss" scoped>
.icp {
	position: fixed;
	text-align: center;
	bottom: 20px;
	margin: 0 auto;
	width: 100%;
	color: #5c6b77;

	.icp-icon {
		width: 20px;
		height: 20px;
		vertical-align: bottom;
	}
}
</style>
